
import { createContext } from 'react';

import type { ApiEndpoints } from './api.endpoints';

export interface ApiContext {
    api?: ApiEndpoints;
}

export const ApiContext = createContext<ApiContext>({
    api: undefined
});
